import type { Card } from '../../types';

export function parseMarkdown(md: string): Card[] {
  const lines = md.split(/\r?\n/);
  const cards: Card[] = [];
  let chapter = 'Allgemein';
  let current: Card | null = null;
  let target: 'front' | 'back' | null = null;

  const flush = () => {
    if (current && current.front.trim() && current.back.trim()) {
      current.front = current.front.trim();
      current.back = current.back.trim();
      cards.push(current);
    }
    current = null;
    target = null;
  };

  for (const raw of lines) {
    const line = raw.replace(/\u00A0/g, ' ');

    const chap = line.match(/^##\s+(.+?)\s*$/);
    if (chap) {
      flush();
      chapter = chap[1].trim();
      continue;
    }

    const card = line.match(/^###\s+Karte\s+(\d+)/i);
    if (card) {
      flush();
      current = {
        id: '',
        number: Number.parseInt(card[1], 10),
        chapter,
        front: '',
        back: '',
        figure: null,
        source: null,
      };
      target = null;
      continue;
    }

    if (!current) continue;

    if (/^---+\s*$/.test(line)) {
      flush();
      continue;
    }

    const front = line.match(/^\*\*Vorderseite:\*\*\s*(.*)$/);
    if (front) {
      target = 'front';
      current.front = front[1];
      continue;
    }

    const back = line.match(/^\*\*Rückseite:\*\*\s*(.*)$/);
    if (back) {
      target = 'back';
      current.back = back[1];
      continue;
    }

    const fig = line.match(/^\*\*Abbildung:\*\*\s*(.+)$/);
    if (fig) {
      current.figure = fig[1].trim();
      target = null;
      continue;
    }

    const src = line.match(/^\*\*Quelle:\*\*\s*(.+)$/);
    if (src) {
      current.source = src[1].trim();
      target = null;
      continue;
    }

    if (target === 'front') current.front += `\n${line}`;
    else if (target === 'back') current.back += `\n${line}`;
  }
  flush();

  cards.forEach((card, index) => {
    card.id = `c${index.toString().padStart(4, '0')}`;
  });

  return cards;
}

export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[char] ?? char);
}

export function inlineMarkdownToHtml(text: string): string {
  let html = escapeHtml(text);
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
  html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/(^|\W)\*([^*\n]+)\*(?=\W|$)/g, '$1<em>$2</em>');
  html = html.replace(/\n/g, '<br />');
  return html;
}
